import React, {useEffect, useState} from "react";
import DocumentLoader from "../util/DocumentLoader";
import {v4} from "uuid";
import {Checkbox, IconButton} from "@mui/material";
import {text} from "../util/constants";
import {useSnackbar} from "notistack";

export default function StackRModal({intervention, ibatApi, onClose}) {

    const [di, setDi] = useState(intervention.externalId)
    const {enqueueSnackbar} = useSnackbar();


    const [reportList, setReportList] = useState([])
    const [quotationList, setQuotationList] = useState([])

    const [loading, setLoading] = useState(false)

    // A maintenance sends no quotation: reserves lead to a quotation request
    // from the client, answered from the quotation page.
    const maintenance = intervention.type.id === 1

    const handleReport = (e) => {
        if (e.target.checked) {
            setReportList([...reportList, e.target.value])
        } else {
            setReportList(reportList.filter(r => r !== e.target.value))
        }
    }

    const handleQuotation = (e) => {
        if (e.target.checked) {
            setQuotationList([...quotationList, +e.target.value])
        } else {
            setQuotationList(quotationList.filter(r => r !== +e.target.value))
        }
    }

    const handleSend = () => {
        setLoading(true)

        const reserves = intervention.type.id === 1 ? intervention.operations
            .filter(op => op.visible && op.metadata?.stateLevel >= 2)
            .map(op => {
                return {
                    codeGravite: getGravite(op.metadata.stateLevel),
                    description: op.commentaireGestionnaire ?? ""
                }
            }) : []

        /*if (reserves.length === 0 && intervention.type.id === 1) {
            reserves.push({
                codeGravite: "mineur",
                description: "Description reserve avec code \"mineur\""
            })
            reserves.push({
                codeGravite: "majeur",
                description: "Description reserve avec code \"majeur\""
            })
            reserves.push({
                codeGravite: "bloquant",
                description: "Description reserve avec code \"bloquant\""
            })
        }*/

        const params = {
            diNumber: di,
            reportList: reportList,
            quotationIdList: maintenance ? [] : quotationList,
            maintenance: maintenance,
            reserves: reserves ?? [],
        }

        console.log(params)

        ibatApi.sendToStackR(params)
            .then(r => {
                onClose()
            })
            .catch(e => {
                console.error(e)
                enqueueSnackbar(text.SNACKBAR_ERROR, {variant: "error"})
                setLoading(false)
            })
    }

    const getGravite = (level) => {
        switch (level) {
            case 2: return "mineur"
            case 3: return "majeur"
            case 4: return "bloquant"
            default: return "mineur"
        }
    }

    useEffect(() => {

    }, [reportList, quotationList]);

    return (
        <div>
            <h1>Envoi des données automatisé.</h1>
            <label>Numéro DI client :</label>
            <input type={"text"} defaultValue={di ?? ""} onChange={(e) => setDi(e.target.value)}/>

            <div className={"secondary-section flex-column"}>
                <h1>Rapport(s)</h1>
                <div className={"flex-row"}>
                    {
                        intervention.generatedReport?.map(n => {
                                return <div>
                                    <DocumentLoader key={v4()} name={n}/>
                                    <Checkbox checked={reportList.includes(n)} value={n} onChange={handleReport}/>
                                </div>
                            }
                        )
                    }
                </div>
            </div>
            {
                !maintenance &&
                <div className={"secondary-section flex-column"}>
                    <h1>Devis</h1>
                    <div className={"flex-row"}>
                        {
                            intervention.quotations?.map(quotation => {
                                    return <div>
                                        {
                                            quotation.odooId && <DocumentLoader name={quotation.odooId} type={"quotation"}/>
                                        }
                                        <Checkbox checked={quotationList.includes(quotation.id)} value={quotation.id}
                                                  onChange={handleQuotation}/>
                                    </div>
                                }
                            )
                        }
                    </div>
                </div>
            }


            <div className={"flex-row"}>
                <IconButton className={"action-btn cancel"} onClick={onClose}>{text.CANCEL}</IconButton>
                <IconButton disabled={loading} className={"action-btn neutral save"}
                            onClick={handleSend}>{text.SEND}</IconButton>
            </div>

        </div>
    )
}